import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { IAssigneeOptionsList, IAssigneeSingleOption, useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { ICardActivityCode } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { Select } from 'components/DesignSystem/Select';
import { OptionsWithAssignee } from 'components/DesignSystem/Select/components/OptionsWithAssignee/OptionsWithAssignee';

interface IAssigneeFilterProps {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string[];
    options?: ICardActivityCode[];
    isSelected?: boolean;
}

export const Assignee = ({
    methods,
    name,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: IAssigneeFilterProps) => {
    const { options, isSuccess } = useAssigneeOptionsList();

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady || !isSuccess) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: isSuccess });
    }, [value, name, filtersStatusRef, isSuccess]);

    const handleChange = (selectedOption: ISelectOption<IAssigneeSingleOption>) => {
        methods?.setValue(name, selectedOption ? selectedOption.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }
        return options?.find((item) => item.value === value) || null;
    };

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <div data-testid="assignee-filter">
                <Controller
                    name={name}
                    control={methods?.control}
                    render={({ field }) => (
                        <Select<IAssigneeOptionsList>
                            {...field}
                            options={options}
                            onChange={handleChange}
                            value={handleValue(value)}
                            components={{
                                Option: OptionsWithAssignee,
                            }}
                            isClearable
                            label={FilterLabels.ASSIGNEE_CARD_BOARD}
                        />
                    )}
                />
            </div>
        </div>
    ) : null;
};
